//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import '@streams-drawer/streams-drawer-summary-section/streams-drawer-summary-section';

import template from './streams-drawer-summary-view.html';

angular.module('curalate').component('streamsDrawerSummaryView', {
  bindings: {
    isFetchingItems: '<',
    summaryItemSets: '<',
    selectStream: '&',
    onOpenCurrentApprovalModal: '&',
    onOpenAutoApprovalModal: '&',
  },
  template,
});
